import React from "react";
import {
  FunctionField,
  ReferenceField,
  Button,
  EditButton,
  TopToolbar,
  Tab,
  TabbedShowLayout,
  Show,
  SimpleShowLayout,
  TextField,
  ReferenceManyField,
  Pagination,
  Datagrid
} from "react-admin";
import { Link } from "react-router-dom";
import CreateIcon from "@material-ui/icons/Add";

const TeamShowActions = ({ basePath, data, resource }) => {
  return (
    <TopToolbar>
      <EditButton basePath={basePath} record={data} />
      {data && (
        <Button
          label="Add Team Season"
          component={Link}
          to={{
            pathname: "/seasonTeams/create",
            state: { record: { team_id: data.id, sportCode: data.sportCode } }
          }}
        >
          <CreateIcon />
        </Button>
      )}
    </TopToolbar>
  );
};

function districtLabel(r) {
  return (
    [
      r.leagueCode,
      r.conferenceCode,
      r.divisionCode,
      r.regionCode,
      r.districtCode
    ].join(" ") +
    "(" +
    r.id +
    ")"
  );
}

const TeamShow = (props) => {
  return (
    <Show actions={<TeamShowActions />} {...props}>
      <TabbedShowLayout>
        <Tab label="summary">
          <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="sportCode" />
            <TextField source="name" />
            <TextField source="teamCode" />
          </SimpleShowLayout>
        </Tab>
        <Tab label="team-seasons">
          <SimpleShowLayout>
            <ReferenceManyField
              reference="seasonTeams"
              target="team_id"
              addLabel={false}
              pagination={<Pagination />}
              fullWidth
            >
              <Datagrid rowClick="show">
                <TextField source="id" />
                <TextField source="seasonCode" />
                <TextField source="sportCode" />
                <ReferenceField
                  label="District"
                  source="district.id"
                  reference="districts"
                >
                  <FunctionField label="District" render={districtLabel} />
                </ReferenceField>
              </Datagrid>
            </ReferenceManyField>
          </SimpleShowLayout>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default TeamShow;
